import { render, staticRenderFns } from "./FormBuilderPreview.vue?vue&type=template&id=233d9781"
import script from "./FormBuilderPreview.vue?vue&type=script&lang=js"
export * from "./FormBuilderPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports